import React from "react";
import { FormControlLabel, Grid, Switch } from "@mui/material";

interface EnableWeekendsProps {
  settingName: string;
  settingValue: string;
  handleUpdate: (settingValue: string) => void;
}

const EnableWeekends: React.FC<EnableWeekendsProps> = ({ settingName, settingValue, handleUpdate }) => {
  return (
    <Grid container display="flex" alignItems="center" spacing={1} size={12}>
      <FormControlLabel
        label={settingName}
        control={
          <Switch
            checked={settingValue === "true"}
            onChange={(_, checked) => handleUpdate(checked.toString())}
            color="primary"
          />
        }
      />
    </Grid>
  );
};

export default EnableWeekends;
